<script lang="ts">
  import type { Snippet } from "svelte";
  import { cn } from "$lib/utils/cn";

  type Props = {
    class?: string;
    children?: Snippet;
    tone?: "neutral" | "accent" | "success" | "warning" | "danger";
  };

  const { class: className, children, tone = "neutral" }: Props = $props();

  const tones: Record<NonNullable<Props["tone"]>, string> = {
    neutral: "bg-(--surface-bg-sunken) text-(--surface-fg-muted)",
    accent: "bg-(--surface-accent)/12 text-(--surface-accent)",
    success: "bg-success-500/15 text-success-600",
    warning: "bg-warning-500/20 text-warning-600",
    danger: "bg-(--surface-danger)/12 text-(--surface-danger)",
  };
</script>

<span
  class={cn(
    "inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium tracking-wide",
    tones[tone],
    className,
  )}
>
  {@render children?.()}
</span>
